import { NgModule } from '@angular/core';
import { TitlecasePipe } from './case-conversion-pipe';

@NgModule({
    imports: [],
    declarations: [
        TitlecasePipe
    ],
    exports: [
        TitlecasePipe
    ]
})
export class CaseConversionModule { }
